import PitchResultToBaseNumberConverter from "../PitchResultToBaseNumberConverter.js";
import BinToQualifiersCountConverter from "./BinToQualifiersCountConverter.js";

class BinToTotalBasesConverter extends BinToQualifiersCountConverter {
    constructor(pitchResultToBaseNumberConverter, pitchResultPath, customResultsProcessor, silent, defaultValue) {
        if (typeof(pitchResultToBaseNumberConverter) === 'undefined') {
            pitchResultToBaseNumberConverter = PitchResultToBaseNumberConverter;
        }

        super(pitchResultToBaseNumberConverter, pitchResultPath, customResultsProcessor, silent, defaultValue);
    }

	_getBinValue(bin, customData) {
		if (!(customData instanceof Array)){
            throw new TypeError('customData must be an array');
        }

        let classified = 0;

        for (let i = 0; i < customData.length; i++) {
            const classifyOn = this.resultsProcessor.getObjectContent(customData[i], this.dataPath);
            classified += this.classifier(classifyOn);
        }

        return classified;
	}
}

export default BinToTotalBasesConverter;